import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, delay, exhaustMap } from 'rxjs';
import { mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';
import { emailEventRuleActions } from './email-event-rule.actions';
import { EmailEventRuleService } from '../../../api/services';

export const emailEventRuleFindEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailEventRuleService)) =>
    actions$.pipe(
      ofType(emailEventRuleActions.find),
      concatMap((props) =>
        service.emailEventRuleControllerFind(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailEventRuleActions.findDone({ data: r.data, state: { value: LoadingState.SUCCESS }, request: props }),
            error: (error: ZetraError) =>
              emailEventRuleActions.findDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailEventRuleFindOneEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailEventRuleService)) =>
    actions$.pipe(
      ofType(emailEventRuleActions.findOne),
      exhaustMap((props) =>
        service.emailEventRuleControllerFindOne(props).pipe(
          delay(500),
          mapResponse({
            next: (r) => emailEventRuleActions.findOneDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              emailEventRuleActions.findOneDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailEventRuleCreateEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailEventRuleService)) =>
    actions$.pipe(
      ofType(emailEventRuleActions.create),
      concatMap((props) =>
        service.emailEventRuleControllerCreate(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailEventRuleActions.createDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              emailEventRuleActions.createDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailEventRuleUpdateEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailEventRuleService)) =>
    actions$.pipe(
      ofType(emailEventRuleActions.update),
      concatMap((props) =>
        service.emailEventRuleControllerUpdate(props).pipe(
          delay(500),
          mapResponse({
            next: (r) =>
              emailEventRuleActions.updateDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              emailEventRuleActions.updateDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);

export const emailEventRuleDeleteEffect = createEffect(
  (actions$ = inject(Actions), service = inject(EmailEventRuleService)) =>
    actions$.pipe(
      ofType(emailEventRuleActions.deleteRule),
      exhaustMap((props) =>
        service.emailEventRuleControllerDelete(props).pipe(
          delay(500),
          mapResponse({
            next: (r) => emailEventRuleActions.deleteRuleDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              emailEventRuleActions.deleteRuleDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    ),
  { functional: true },
);
